<template>
  <div class="app-container">
    <!-- 公告 -->
    <!-- <Notice ref="noticeRef" @listenNoticeBtn="listenNoticeBtn" /> -->
    <div class="title">
      <span class="name">首页总览</span>
      <span class="time">更新时间：{{ data.lastUpdate }}</span>
    </div>
    <div class="dashboard-header">
      <div
        class="dashboard-header-item"
        style="
          background: linear-gradient(180deg, #ffe7e7 0%, #ffffff 100%), #ffffff;
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
        "
        v-loading="loading"
      >
        <div class="dashboard-header-left">
          <div class="dashboard-header-left-title">
            <span style="margin-right: 5px">昨日入库量</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="最小赋码单元"
              placement="bottom"
            >
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="dashboard-header-left-num">
            {{ data.header.today_StoreIn }}
          </div>
          <div class="dashboard-header-left-desc">
            <span>同比前日</span>
            <span
              class="dashboard-header-left-desc-con"
              :style="`color:${data.header.today_StoreIn_PercentColor}`"
              >{{ data.header.today_StoreIn_Percent }}</span
            >
          </div>
        </div>
        <div class="dashboard-header-right">
          <img
            class="dashboard-header-right-img"
            src="@/assets/dashboard/ruku.png"
            alt=""
          />
        </div>
      </div>
      <div
        class="dashboard-header-item"
        style="
          background: linear-gradient(180deg, #e7fff4 0%, #ffffff 100%), #ffffff;
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
        "
        v-loading="loading"
      >
        <div class="dashboard-header-left">
          <div class="dashboard-header-left-title">
            <span style="margin-right: 5px">昨日出库量</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="最小赋码单元"
              placement="bottom"
            >
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="dashboard-header-left-num">
            {{ data.header.today_StoreOut }}
          </div>
          <div class="dashboard-header-left-desc">
            <span>同比前日</span>
            <span
              class="dashboard-header-left-desc-con"
              :style="`color:${data.header.today_StoreOut_PercentColor}`"
              >{{ data.header.today_StoreOut_Percent }}</span
            >
          </div>
        </div>
        <div class="dashboard-header-right">
          <img
            class="dashboard-header-right-img"
            src="@/assets/dashboard/chuku.png"
            alt=""
          />
        </div>
      </div>
      <div
        class="dashboard-header-item"
        style="
          background: linear-gradient(180deg, #fff4e7 0%, #ffffff 100%), #ffffff;
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
        "
        v-loading="loading"
      >
        <div class="dashboard-header-left">
          <div class="dashboard-header-left-title">
            <span>昨日往来企业</span>
          </div>
          <div class="dashboard-header-left-num">
            {{ data.header.today_RelationEnterprise }}
          </div>
          <div class="dashboard-header-left-desc">
            <span>同比前日</span>
            <span
              class="dashboard-header-left-desc-con"
              :style="`color:${data.header.today_RelationEnterprise_PercentColor}`"
              >{{ data.header.today_RelationEnterprise_Percent }}</span
            >
          </div>
        </div>
        <div class="dashboard-header-right">
          <img
            class="dashboard-header-right-img"
            src="@/assets/dashboard/wanglai.png"
            alt=""
          />
        </div>
      </div>
      <div
        class="dashboard-header-item"
        style="
          background: linear-gradient(180deg, #e7efff 0%, #ffffff 100%), #ffffff;
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
        "
        v-loading="loading"
      >
        <div class="dashboard-header-left">
          <div class="dashboard-header-left-title">
            <span>全部往来企业</span>
          </div>
          <div class="dashboard-header-left-num">
            {{ data.header.all_RelationEnterprise }}
          </div>
          <div class="dashboard-header-left-desc">
            <span>往来单据数</span>
            <span
              class="dashboard-header-left-desc-con"
              :style="`color:${data.header.all_RelationEnterprise_CountColor}`"
              >{{ data.header.all_RelationEnterprise_Count }}</span
            >
          </div>
        </div>
        <div class="dashboard-header-right">
          <img
            class="dashboard-header-right-img"
            src="@/assets/dashboard/quanbuwanglai.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="dashboard-footer">
      <div class="dashboard-footer-left" v-loading="loading">
        <div class="dashboard-footer-left-title">药品排名</div>
        <div class="dashboard-footer-left-tag">
          <div
            v-for="(v, i) in tag"
            :key="i"
            :class="['footer-left-tag-item', { blue: i === tagIndex }]"
            @click="handleTag(i)"
          >
            <div>{{ v }}</div>
            <div
              :class="['footer-left-tag-item-icon', { blue: i === tagIndex }]"
            />
          </div>
        </div>
        <div class="dashboard-footer-left-chart">
          <div class="footer-left-chart">
            <div ref="radiusChartsRef" style="height: 280px" />
          </div>
          <div class="footer-left-chart-text">
            <div class="chart-text-item" style="width: 50%">
              <div class="text-item-name">药品通用名</div>
              <div
                v-for="(v, i) in circleChartsData.items"
                :key="v.name"
                class="text-item-value"
              >
                <div
                  class="text-item-value-icon"
                  :style="`background:${backgroundColor[i]}`"
                />
                <EllipsisTooltip
                  :content="v.name"
                  class="batch-info-item-value"
                >
                  {{ v.name }}
                </EllipsisTooltip>
              </div>
            </div>
            <div class="chart-text-item" style="width: 20%">
              <div class="text-item-name">
                {{ tagIndex === 0 ? "入库量" : "出库量" }}
              </div>
              <div
                v-for="v in circleChartsData.items"
                :key="v.name"
                class="text-item-value"
              >
                {{ v.count }}
              </div>
            </div>
            <div class="chart-text-item" style="width: 20%">
              <div class="text-item-name">占比</div>
              <div
                v-for="v in circleChartsData.items"
                :key="v.name"
                class="text-item-value"
              >
                {{ v.percent }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard-footer-right" v-loading="loading">
        <div class="footer-right-title">
          <div class="right-title">出入库趋势图</div>
          <el-tooltip
            class="item"
            effect="dark"
            content="最多展示30日"
            placement="bottom"
          >
            <i class="el-icon-warning-outline" />
          </el-tooltip>
        </div>
        <div ref="barChartsRef" style="height: 337px" />
      </div>
    </div>

    <!-- 付款 -->
    <Purchase ref="PurchaseRef" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import Purchase from "@/components/Purchase";
import EllipsisTooltip from "@/components/EllipsisTooltip";

export default {
  name: "Dashboard",
  components: { Purchase, EllipsisTooltip },
  data() {
    return {
      tag: ["药品入库量", "药品出库量"],
      tagIndex: 0,
      data: {
        header: {},
        circleCharts: [],
        lineChart: {},
      },
      circleChartsData: {},
      backgroundColor: [
        "#1BC88E",
        "#4076F2",
        "#FF1616",
        "#F48E12",
        "#FFC12F",
        "#D2D2D2",
      ],
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    listenNoticeBtn() {
      this.$refs.PurchaseRef.show();
    },
    handleTag(value) {
      this.tagIndex = value;
      this.circleChartsData = this.data.circleCharts[value];
      this.fetchPie(this.circleChartsData);
    },
    fetchPie(circleCharts) {
      const color = [
        "#1BC88E",
        "#4076F2",
        "#FF1616",
        "#F48E12",
        "#FFC12F",
        "#D2D2D2",
      ];
      const userOption = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "transparent",
          padding: 0,
          extraCssText:
            "box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3); border-radius: 8px;",
          formatter: (params) => {
            const index = circleCharts.items.findIndex(
              (item) => item.name === params.name
            );
            const currentColor = color[index] || color[0];
            const currentData = circleCharts.items[index];
            const valueStr = currentData ? currentData.valueStr : params.value;
            return `
              <div style="padding: 7px 0; ">
                <div style="font-weight: 500; font-size: 12px; color: #242b35;  margin-left: 12px;">${circleCharts.text}</div>
                <div style="font-weight: 400; font-size: 11px; color: #666666; margin-left: 12px;">共${circleCharts.totalValue}</div>
                <div style="display: flex; align-items: center; font-weight: 400; font-size: 12px; color: #242b35; margin-right: 12px; margin-left: 12px;">
                  <div style="width: 5px; height: 5px; border-radius: 50%; margin-right: 10px; background: ${currentColor};"></div>
                  <div style="white-space: nowrap; margin-right:20px;">${params.name}</div>
                  <div style="white-space: nowrap; margin-right:20px; text-align: left;">${valueStr}</div>
                  <div style="white-space: nowrap; text-align: left;">${params.percent}%</div>
                </div>
              </div>
            `;
          },
          position: (point) => point,
        },
        title: {
          text: circleCharts.total,
          subtext: circleCharts.text,
          left: "center",
          top: "120",
          textStyle: {
            fontSize: 20,
            color: "#333",
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              disabled: false,
              scale: false,
              label: {
                show: false,
                fontSize: 12,
              },
            },
            labelLine: {
              show: false,
            },
            color: [
              "#1BC88E",
              "#4076F2",
              "#FF1616",
              "#F48E12",
              "#FFC12F",
              "#D2D2D2",
            ],
            data: circleCharts.items,
          },
        ],
      };
      const e = echarts.init(this.$refs.radiusChartsRef);
      e.setOption(userOption);
    },
    fetchBar(lineChart) {
      const userOption = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "transparent",
          padding: 0,
          extraCssText:
            "box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3); border-radius: 8px;",
          formatter: (params) => {
            const formatNumber = (num) => {
              return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            };
            let html = `
              <div style="padding: 7px 0; min-width: 100px;">
                <div style="font-weight: 500; font-size: 12px; color: #242b35;  margin-left: 12px;">${
                  params[0].axisValue
                }</div>
                <div style="display: flex; align-items: center; font-weight: 400; font-size: 12px; color: #242b35; margin-right: 12px; margin-left: 12px;">
                  <div style="width: 5px; height: 5px; border-radius: 50%; margin-right: 10px; background: ${
                    params[0].color
                  };"></div>
                  <div style="white-space: nowrap; width: 50px;">${
                    params[0].seriesName
                  }</div>
                  <div style="white-space: nowrap; width: 60px; text-align: left;">${formatNumber(
                    params[0].value
                  )}</div>
                </div>
            `;
            if (params[1]) {
              html += `
                <div style="display: flex; align-items: center; font-weight: 400; font-size: 12px; color: #242b35; margin-right: 12px; margin-left: 12px;">
                  <div style="width: 5px; height: 5px; border-radius: 50%; margin-right: 10px; background: ${
                    params[1].color
                  };"></div>
                  <div style="white-space: nowrap; width: 50px;">${
                    params[1].seriesName
                  }</div>
                  <div style="white-space: nowrap; width: 60px; text-align: left;">${formatNumber(
                    params[1].value
                  )}</div>
                </div>
              `;
            }
            html += `</div>`;
            return html;
          },
          position: (point) => point,
        },
        legend: {
          right: "20",
          data: ["入库", "出库"],
        },
        color: ["#FF2121", "#1BC88E"],
        xAxis: [
          {
            type: "category",
            data: lineChart.dates,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 80,
            height: 10,
            bottom: 10,
            backgroundColor: "#f5f5f5",
            borderColor: "#ddd",
            fillerColor: "rgba(64, 158, 255, 0.2)",
            handleStyle: {
              color: "#409eff",
              borderColor: "#409eff",
            },
            textStyle: {
              color: "#333",
            },
          },
        ],
        series: lineChart.series,
      };
      const e = echarts.init(this.$refs.barChartsRef);
      e.setOption(userOption);
    },
    async fetchData() {
      this.loading = true;
      const { data } = await this.$api.basic.Index();
      this.data = data;
      this.circleChartsData = data.circleCharts[0];
      this.fetchPie(data.circleCharts[0]);
      this.fetchBar(data.lineChart);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
